import { type ProgramEventInvitee, getUserName, isRegisteredProgramInvitee } from 'models';
import { AvatarWrapper, CheckCircleFillIcon } from 'ui';
import { useUser } from 'features/auth';
import { IconDirectMessageButton } from 'features/chat';

type P = {
  user: ProgramEventInvitee;
};

const EventInviteeAvatar = ({ user }: P) => {
  const { railsUserData: viewer } = useUser();

  return (
    <AvatarWrapper
      avatar={{
        badge: {
          icon: <CheckCircleFillIcon backgroundColor="white" shape="circle" size="extra-extra-small" type="success" />,
        },
        photo: isRegisteredProgramInvitee(user) ? user.profilePhoto : undefined,
      }}
      extra={isRegisteredProgramInvitee(user) ? <IconDirectMessageButton legacyUserId={user.id} /> : null}
      user={{
        isViewer: isRegisteredProgramInvitee(user) ? user.id === viewer.id : false,
        name: isRegisteredProgramInvitee(user) ? getUserName(user) : user.email,
      }}
    />
  );
};

export default EventInviteeAvatar;
